/** Preset prayer intentions for Libro "Rezar por" orbs. */
export const PRAY_FOR_PRESETS = [
  {
    id: 'god',
    label: 'Dios',
    image: '/gallery-images/pray-for/god.jpg',
  },
  {
    id: 'jesus',
    label: 'Jesús',
    image: '/gallery-images/pray-for/jesus.jpg',
  },
  {
    id: 'angels',
    label: 'Ángeles',
    image: '/gallery-images/pray-for/angels.jpg',
  },
  {
    id: 'mary',
    label: 'María',
    image: '/gallery-images/pray-for/mary.jpg',
  },
  {
    id: 'church',
    label: 'La Iglesia',
    emoji: '⛪',
  },
  {
    id: 'world',
    label: 'El mundo',
    emoji: '🌍',
  },
  {
    id: 'saints',
    label: 'Los santos',
    emoji: '✨',
  },
];
